import Vue from 'vue'
import Vuex from 'vuex'

let t = null

const overlayStore = {
  namespaced: true,
  state: {
    showModal: false,
    showProgress: false,
    currentModalView: '',
    notifications: [],
    loading: '',
    overlayParameters :{},
    confirmation: {
      msg: '',
      callback: null
    }
  },
  mutations: {
    SET_CURRENT_MODAL_VIEW (state, value) {
      state.currentModalView = value
    },
    SET_SHOW_MODAL_OVERLAY (state, value) {
      state.showModal = value
    },
    SET_SHOW_PROGRESS_OVERLAY (state, value) {
      state.showProgress = value
    },
    PUSH_CONFIRMATION (state, object) {
      if(object.hasOwnProperty('msg')) state.confirmation.msg = object.msg
      if(object.hasOwnProperty('callback')) state.confirmation.callback = object.callback
    },
    CLEAR_CONFIRMATION (state) {
      state.confirmation.msg = ''
      state.confirmation.callback = null
    },
    PUSH_NOTIFICATION (state, object) {
      state.notifications.push(object)
    },
    POP_NOTIFICATION (state) {
      state.notifications.pop()
    },
    SET_LOADING_STATUE (state, value) {
      state.loading = value
    },
    SET_PARAMETERS (state, value) {
      state.overlayParameters = value
    }   
  },
  actions: {
    toggleModal ({ commit, state }, value) {
      commit('SET_SHOW_MODAL_OVERLAY', value)
    },
    showModal ({ commit, state, dispatch }, templateName) {
      commit('SET_CURRENT_MODAL_VIEW', templateName)
      dispatch('toggleModal', true)
    },
    showProgressOverlay ({ commit, state }, value) {
      commit('SET_SHOW_PROGRESS_OVERLAY', value)
    },
    pushNotification ({ commit, state }, notificationObject) {
      commit('PUSH_NOTIFICATION', notificationObject)
      let t = setTimeout(() => {
        commit('POP_NOTIFICATION')
      }, 2000)
    },
    pushConfirmation({ commit, state }, confirmationObject) {
      commit('PUSH_CONFIRMATION', confirmationObject)
    },
    clearConfirmation({commit}) {
      commit('CLEAR_CONFIRMATION')
    },
    appIsLoading({commit}) {
      commit('SET_LOADING_STATUE', 'loading')
    },
    appCompletedLoading({commit}) {
      clearTimeout(t)
      commit('SET_LOADING_STATUE', 'completed')
      t = setTimeout(()=> {
        commit('SET_LOADING_STATUE', '')
      }, 400)

    },
    setParameters({ commit, state }, value){
      commit('SET_PARAMETERS', value)
    }

  }
}

export default overlayStore



// WEBPACK FOOTER //
// ./src/stores/overlay.js